module.exports = __webpack_public_path__ + "img/20.27b76b09.png";